import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Box,
} from "@mui/material";
import { adminLogin } from "../utils/utils";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";
const Password = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const username = location.state?.username || localStorage.getItem("username");
  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      setErrorMessage("New password and confirm password do not match.");
      return;
    }
    if (!username) {
      setErrorMessage("Username missing. Please login again.");
  return;
    }

    const adminHeader = await adminLogin();
    try {
      const userIdResponse = await fetch(
        `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?username=${username}`,
        {
          method: "GET",
          headers: adminHeader,
        },
      );
      const createdUser = (await userIdResponse.json())[0];

      const userId = createdUser.id;

      const response = await fetch(
        `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users/${userId}/reset-password`,
        {
          method: "PUT",
          headers: adminHeader,
          body: JSON.stringify({
            type: "password",
            value: newPassword,
            temporary: false, // Forces the user to change password
          }),
        },
      );





      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.message || "Failed to change password.");
        return;
      } else {
        setSuccessMessage("Password changed successfully!");
        setErrorMessage("");
        const loginResponse = await fetch(process.env.REACT_APP_OAUTH_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            username: localStorage.getItem("username"),
            password: newPassword,
            client_id: "eVyoog-Client",
            grant_type: "password",
          }),
        });


        const data = await loginResponse.json(); 

         // 🔴 Invalid client case
  if (data.error === "invalid_client") {
    localStorage.clear(); // remove tokens if any
    setErrorMessage("Please login again.");
    navigate("/");
    return;
  }

        if (!loginResponse.ok || !data.access_token) {
          setErrorMessage(data.error_description || "Auto login failed.");
          return;
        }
        if (data.access_token && data.access_token.split(".").length === 3) {
          localStorage.setItem("vyg_access_token", data.access_token);
        } else {
          setErrorMessage("Invalid login token received.");
          return;
        }


        
        localStorage.setItem("vyg_refresh_token", data.refresh_token);

        const decodedToken = jwtDecode(data.access_token);
        localStorage.setItem("vyg_login_user", decodedToken.given_name || "Unknown user");


        const redirectTo = new URLSearchParams(location.search).get("redirect") || "/ticket";
        navigate(redirectTo);
        window.location.reload();

      }



    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
    if (confirmPassword && e.target.value !== confirmPassword) {
      setErrorMessage("New password and confirm password do not match.");
    } else {
      setErrorMessage("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (newPassword && e.target.value !== newPassword) {
      setErrorMessage("New password and confirm password do not match.");
    } else {
      setErrorMessage("");
    }
  };

  return (
    <Box
      sx={{
        backgroundImage: "linear-gradient(to right, #4facfe, #00f2fe)",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={6} sx={{ borderRadius: "15px", overflow: "hidden" }}>
          <Box
            sx={{ backgroundColor: "#1976d2", color: "#fff", padding: "15px" }}
          >
            <Typography variant="h5" align="center">
              Change Password
            </Typography>
          </Box>
          <CardContent sx={{ padding: "30px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="New Password"
                  type="password"
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  error={!!errorMessage && newPassword !== confirmPassword}
                  helperText={
                    !!errorMessage && newPassword !== confirmPassword
                      ? "Passwords do not match."
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Confirm New Password"
                  type="password"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  error={!!errorMessage && newPassword !== confirmPassword}
                  helperText={
                    !!errorMessage && newPassword !== confirmPassword
                      ? "Passwords do not match."
                      : ""
                  }
                />
              </Grid>
              {errorMessage && (
                <Grid item xs={12}>
                  <Typography color="error" variant="body2" align="center">
                    {errorMessage}
                  </Typography>
                </Grid>
              )}
              {successMessage && (
                <Grid item xs={12}>
                  <Typography color="success" variant="body2" align="center">
                    {successMessage}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </CardContent>
          <CardActions>
            <Box display="flex" justifyContent="center" width="100%">
              <Button
                variant="contained"
                color="primary"
                onClick={handleChangePassword}
                disabled={
                  !newPassword ||
                  !confirmPassword ||
                  newPassword !== confirmPassword
                }
                sx={{ width: "90%", padding: "10px", fontSize: "16px" }}
              >
                Change Password
              </Button>
            </Box>
          </CardActions>
        </Card>
      </Container>
    </Box>
  );
};

export default Password;
